export default function genererArrayEnseignes(response) {
  const arrayEnseignes = response.map((el) => ({
    type: el.libelleTypeMarque,
    marque: el.nom,
    urlLogo: el.urlLogoMarque,
    idExterne: el.id,
    enseignePrincipale: false,
  }));
  return arrayEnseignes;
}
